<script>
  import RandomStar from "./Minor/RandomStar.svelte";

  // Copy link to clipboard
  let copied = false;

  function copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = "https://impact.collaborativefund.com/";
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    copied = true;
  }
</script>

<div class="conclusion">
  <RandomStar />
  <RandomStar />
  <RandomStar />
  <RandomStar />
  <RandomStar />
  <RandomStar />
  <div class="content">
    <h1>
      Did we miss something? <br /><a
        class="styled-link email"
        href="mailto:research@collabfund.com"
        target="_blank"
        >research<wbr />@collabfund.com
      </a>
    </h1>
    <h2>Share this project:</h2>
    <div class="buttons">
      <a
        class="share-link"
        href="https://twitter.com/intent/tweet?text=Check out this interactive on the history of impact investing by @collabfund https://impact.collaborativefund.com/&original_referer=https://impact.collaborativefund.com/"
        target="_blank"
        rel="noopener noreferrer">Twitter</a
      >
      <a
        class="share-link"
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fimpact.collaborativefund.com"
        target="_blank"
        rel="noopener noreferrer">Facebook</a
      >
      <button class="share-link" on:click={copyToClipboard}
        >{copied ? "Copied!" : "Copy link"}</button
      >
    </div>
  </div>
</div>

<style>
  .conclusion {
    font-family: var(--font-subhead);
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    text-align: center;
  }

  .content {
    max-width: 760px;
    margin: 0 auto;
  }

  h1 {
    margin: 0;
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  h2 {
    font-family: var(--font-subhead);
    letter-spacing: 0.1rem;
    font-weight: 100;
    font-size: 1rem;
    margin-top: 0;
    letter-spacing: 0.4px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .share-link {
    color: white;
    background-color: rgba(0, 0, 0, 0.1);
    outline: none;
    border: none;
    padding: 0.5rem 0.75rem;
    border-radius: 5px;
    margin: 0 0.15rem;
    cursor: pointer;
  }

  .share-link:hover,
  .share-link:focus,
  .share-link:active {
    background-color: rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 568px) {
    h1 {
      font-size: 1.95rem;
    }
  }

  .email {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1rem;
  }
  @media screen and (max-width: 460px) {
    .content {
      max-width: 100%;
    }

    h1 {
      font-size: 1.25rem;
    }

    .email {
      font-size: 1rem;
    }

    h2 {
      font-size: 0.85rem;
    }

    .share-link {
      font-size: 0.85rem;
    }
  }
</style>
